import SectionPage from '../components/SectionPage';

export default function EconomiaCircular() {
  return (
    <SectionPage
      title="Economía Circular"
      intro="Economía circular y transición verde, con foco en innovación ambiental y nuevos modelos productivos."
      sections={[
        {
          title: 'Contexto',
          id: 'contexto',
          body: <p>Recycla participa en conversaciones sobre economía verde, transición ecológica e innovación sustentable.</p>,
        },
      ]}
    />
  );
}
